// Auto-generated by scripts/generate-version.js at build time. Do not edit.
export const APP_VERSION = 'f06aff0-1791194423393'
